import type { RouteLocationNormalized } from 'vue-router'

/**
 * Auth-layout routes (login, forgot/reset password, email verification) are not
 * auth-gated. Logged-in users are normally bounced to `/` so they never see the
 * login screen again.
 *
 * Password-reset and email-verification links, however, must stay reachable even
 * when a (possibly stale) `professional_auth_token` cookie is present:
 * `isLoggedIn` is derived from cookie presence alone, so a dead token still reads
 * as "logged in". Without this opt-out the guard redirects the link to `/`, the
 * stale token 401s, and the user is kicked to the "session expired" screen
 * instead of being able to set a new password. Pages opt out via
 * `meta.allowAuthenticated: true`.
 */
export function shouldRedirectAuthenticatedToHome(
  to: RouteLocationNormalized,
  isLoggedIn: boolean,
): boolean {
  if (!isLoggedIn) return false
  return to.meta.allowAuthenticated !== true
}

export function isDisabledByFeatureFlag(
  to: RouteLocationNormalized,
  isEnabled: (flag: string) => boolean,
): boolean {
  const flag = to.meta.featureFlag
  return typeof flag === 'string' && !isEnabled(flag)
}
